import React, { useState } from "react";
import "./ForgetPassword.css";
import { forgetPassword } from "../../api/index";
import Swal from "sweetalert2";
import { useMutation } from "react-query";
import { Link, useHistory } from "react-router-dom";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const history = useHistory();
  const { mutate } = useMutation(forgetPassword, {
    onSuccess: (data) => {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Success! Check your email to reset your password",
        showConfirmButton: false,
        timer: 2000,
      });
      history.push("/sign-in");
    },
    onError: (error) => {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Forgot password failed!",
        text: error?.response?.data?.message,
        showConfirmButton: false,
        timer: 2000,
      });
    },
  });

  const validateEmail = () => {
    if (email.trim() === "") {
      setEmailError("Oops! Email field cannot be empty");
      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError("Please Enter a valid email address");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const clickHandler = async (e) => {
    e.preventDefault();

    validateEmail();

    if (validateEmail()) {
      try {
        mutate({ email });
      } catch (e) {
        console.log(e);
      }
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Email can't be empty",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  return (
    <div className="forget_page">
      <div className="doctor_forget_div">
        <div className="forget_img">
          <img src="/img/ladydoctor.jpg"></img>
        </div>
      </div>
      <div className="forget_back">
        <div className="forget_div">
          <div className="forget_logo">
            <Link to={"/"}>
              <img src="/img/logo1.png"></img>
            </Link>
          </div>
          <div className="reset_heading">Forget Password</div>
          <div class="forget_p">
            Your email address below and we'll get you back on track.
          </div>
          <div className="forget_input">
            {/* <div className=""> */}
            <img src="/img/mail.svg" style={{ marginTop: "3px" }}></img>
            {/* </div> */}
            <input
              name="Email"
              className="email_in"
              placeholder="Email Address"
              onChange={(e) => {
                setEmail(e.target.value);
                validateEmail();
              }}
              onBlur={validateEmail}
              style={{ marginTop: "-12px" }}
            />
            {emailError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
              >
                {emailError}
              </span>
            )}
          </div>
          <div className="forget-menu">
            <button
              className="btn-style"
              style={{ fontWeight: "500", fontSize: "14px" }}
              onClick={clickHandler}
            >
              DONE
            </button>
            <div className="img_wrap_end_1" style={{ height: "47px" }}>
              <img src="/img/chevron-right.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
